<div aria-label="alert">
  <div>
    <p *ngFor="let alert of alerts">
      <ngb-alert [type]="[alert.type]" (close)="closeAlert(alert)">{{ alert.message }}</ngb-alert>
    </p>
  </div>
</div>
